import { UserFromAPI } from "../types/auth.types";

export const getUserDefaultClinic = (user: UserFromAPI | undefined) => {
    const activeStaffAgreement = user?.staff_agreement?.find((staffAgreement) => staffAgreement.status !== "inactive");
    const userDefaultClinic = activeStaffAgreement?.default_clinic;
    return userDefaultClinic;
};
